export default __webpack_public_path__ + "static/media/user_add.cf8e06a5.svg";